"use client";

import { AnimatedBookCard } from "@/components/ui/AnimatedBookCard";
import { Reveal } from "@/components/ui/Reveal";
import {
  bookHasDetailPage,
  type PublishedBookItem,
} from "@/data/published-books";

export type PublishedBooksGridSectionProps = {
  heading?: string;
  description?: string;
  books?: PublishedBookItem[];
  className?: string;
};

export function PublishedBooksGridSection({
  heading = "Each Manuscript We Handle Becomes a Book That is Ready for the World",
  description = "With UBP's book publishing expertise, you can turn your manuscript into a standout book that reaches readers confidently, with professional editing, design, and publishing support every step of the way.",
  books = [],
  className,
}: PublishedBooksGridSectionProps) {
  return (
    <section
      className={["bg-white py-12 sm:py-14 lg:py-16", className]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal variant="up">
          <div className="mx-auto mb-10 max-w-4xl text-center">
            <h2 className="font-heading text-[1.75rem] font-bold leading-tight tracking-wide text-[#29361a] sm:text-[2.25rem] lg:text-[2.5rem]">
              {heading}
            </h2>
            <p className="mx-auto mt-4 max-w-3xl text-sm leading-[1.8] text-[#505050] sm:text-base">
              {description}
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-4 md:grid-cols-3 lg:grid-cols-4 lg:gap-2">
          {books.map((book, index) => (
            <Reveal key={book.title} variant="up" delayMs={Math.min(index * 60, 480)}>
              <AnimatedBookCard
                {...book}
                exploreLabel="Explore More"
                exploreDisabled={!bookHasDetailPage(book.exploreHref)}
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
